import {FilteringGridWithBulkOperations} from './filtering_grid_with_bulk_operations.js';

export const ExperiencesView = Backbone.View.extend({
  el: '#experiences',
  initialize: function() {
    this.editable = this.options.editable
    this.data = this.options.data
    this.tags = _.uniq(this.options.data.reduce(this.selectTags, []));
    this.clubId = this.options.clubId
    this.userDateFormat = this.options.userDateFormat;
    this.settings = this.options.settings || { }
    this.savedSettings = this.settings.saved || { }

    var params = rwgps.Utils.getQueryParameters(window.location.search)
    var viewingArchives = params.archive === 'true'
    this.$el.toggleClass('showingArchives', viewingArchives)
    this.$el.toggleClass('showingLibrary', !viewingArchives)

    this.initTagInputBoxes();
    this.initGrid()

    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
    this.resizeGrid();
    this.resizeGrid();

    $(window).resize(_.debounce(() => {
      this.resizeGrid();
    }, 100));
  },
  events: {
    // filtering
    'keyup .filter_by_any': 'filterTextInputChanged',
    'change .filter_by_tag': 'filtersChanged',
    'change .filter_by_publish_status': 'filtersChanged',
    // bulk operations
    'click .bulk-op-disabled': 'showDisabledMessage',
    'click .show_bulk_op': 'showBulkOp',
    'click .batch_delete': 'batchDelete',
    'click .batch_make_active': 'batchMakeActive',
    'click .batch_make_inactive': 'batchMakeInactive',
    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
    'click .batch_archive': 'batchArchive',
    'click .batch_unarchive': 'batchUnarchive',
    // misc
    'click .grid_height_increase': 'increaseGridHeight',
    'click .grid_height_decrease': 'decreaseGridHeight',

    'mousedown .route-info': 'experienceAudits'
  },

  initGrid: function() {
    const data = this.data
    const formatters = FilteringGridWithBulkOperations.formatters

    // column definitions
    const columns = [
      {id:"name", name:'Name', field:"name", sortable:true, formatter: formatters.eventName.bind(this), editor:Slick.Editors.Text},
      {id:"reference_id", name:'Reference ID', field:"reference_id", sortable:true},
      {id:"tags", name:'Tags', field:"tags", sortable:true, formatter: formatters.tags},
      {id:"starts_on", name:'Starts On', field:"starts_on", sortable:true, formatter: formatters.date.bind(this)},
      {id:"created_at", name:'Created', field:"created_at", sortable:true, formatter: formatters.date.bind(this)},
      {id:"routes_count", name:'Routes', field:"routes_count", sortable:true},
      {id:"publish_status", name:'Publish Status', field:"publish_status", sortable:true, formatter: formatters.capitalize.bind(this)},
      {id:"info", name: '', field:"info", formatter: formatters.info, resizable: false}
    ]

    const columnWidths = Object.assign({
      info: 45,
      edit: 10
    }, this.savedSettings.columnWidths || {})
    columns.forEach(column => column.width = columnWidths[column.id])

    const anyFilter = this.$('.filter_by_any')
    const tagFilter = this.$('.filter_by_tag')
    const publishStatusFilter = this.$('.filter_by_publish_status')
    const filterAccessors = new Map(Object.entries({
      any: anyFilter.val.bind(anyFilter),
      publish_status: publishStatusFilter.val.bind(publishStatusFilter),
      tag_names: tagFilter.select2.bind(tagFilter, "val")
    }))

    this.grid = new FilteringGridWithBulkOperations(data, {
      target: '#experiences_table',
      columns: columns,
      editable: this.editable,
      editPath: (object) => `/experiences/${object.id}/edit`,
      updatePath: (id) => `/experiences/${id}.json`,
      updateParam: 'experience',
      ignoreCaseOnSort: ['name', 'reference_id'],
      filterAccessors: filterAccessors,
      settingsOpts: this.settings.opts
    });

    this.grid.sortingFn('tags', (a, b) => {
      const x = (a.tag_names || []).join().toUpperCase(), y = (b.tag_names || []).join().toUpperCase();
      return (x==y ? 0 : (x > y ? 1 : -1));
    })

    var params = rwgps.Utils.getQueryParameters(window.location.search)
    var viewingArchives = params.archive === 'true'

    this.grid.enableFiltering([
      {field: 'any', type: 'anyString', extra: ['name', 'reference_id']},
      {field: 'tag_names', type: 'arraySubset'},
      {field: 'publish_status', type: 'array'},
      {field: 'archived_at', type: 'function', extra: this.getFilterByViewingArchives(viewingArchives)}
    ]);

    this.grid.enableBulkOperations({
      bulkDeletePath: `/experiences/batch_destroy.json`,
      bulkUpdateAttributePath: `/clubs/${this.clubId}/batch_set_experiences_attr.json`,
      idsParam: 'experience_ids'
    });

    if (this.savedSettings.sortCol) {
      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc)
    }

    const self = this
    this.grid.slickGrid.onSelectedRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    this.grid.dataView.onRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    self.updateBulkOpVisibility()

    // As it turns out, we need to have this here so any data stuff that happens before filters
    // get changed will receive a copy of the current filters values.
    // The routes_view.js gets around this, because makeSlider() triggers this call as a side-effect.
    this.grid.filterInputsChanged()
  },

  /*
   * filtering
   */

  filterTextInputChanged: function(e) {
    // clear on escape
    if(e.which == 27) e.currentTarget.value = '';
    this.filtersChanged()
  },

  filtersChanged: function() {
    if (this.grid) { this.grid.filterInputsChanged() }
  },

  /*
   * bulk operations
   */

  showDisabledMessage: function(e) {
    const message = $(e.currentTarget).data('disabled')
    $("#disabled-op-content").html(message)
    $("#disabled-op").modal("show")

    e.preventDefault()
    e.stopImmediatePropagation()
  },

  showBulkOp: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op');
    const show = !this.$('.bulk_op_' + bulkOp).is(':visible');
    this.$('.bulk_op').hide();
    if(show)
      this.$('.bulk_op_' + bulkOp).show();
    return false;
  },

  batchDelete: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      return
    } else {
      const message = `Are you sure? This will delete ${items.length} selected Experience${items.length > 1 ? 's' : ''}`
      customConfirm(message, () => this.grid.deleteSelectedItems())
    }
    return false
  },

  batchMakeActive: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      customAlert("No experiences selected. Click the checkboxes next to the experiences you'd like to enable first.");
    } else {
      customConfirm(`Are you sure? This will enable ${items.length} selected experience${items.length > 1 ? 's' : ''}`, () => {
        this.grid.setAttributeOnSelectedItems('active', true, (item) => {
          item.publish_status = 'queued'
        })
      })
    }
    return false
  },

  batchMakeInactive: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      customAlert("No experiences selected. Click the checkboxes next to the experiences you'd like to disable first.")
    } else {
      customConfirm(`Are you sure? This will disable ${items.length} selected experience${items.length > 1 ? 's' : ''}`, () => {
        this.grid.setAttributeOnSelectedItems('active', false, (item) => {
          item.publish_status = 'unpublished'
        })
      })
    }
    return false
  },

  batchArchive: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert("No routes selected. Click the checkboxes next to the experiences you'd like to archive first.");
    } else {
      customConfirm('Are you sure? This will archive ' + items.length + ' selected experience' + (items.length === 1 ? '' : 's'), () => (
        this.grid.setAttributeOnSelectedItems('archived_at', new Date()).always(() => {
          this.grid.setSelectedRows([]);
          this.filtersChanged();
        })
      ));
    }
    return false;
  },

  batchUnarchive: function() {
    const items = this.grid.selectedItems;
    if(!items.length) {
      customAlert("No routes selected. Click the checkboxes next to the experiences you'd like to unarchive first.");
    } else {
      customConfirm('Are you sure? This will unarchive ' + items.length + ' selected experience' + (items.length === 1 ? '' : 's'), () => (
        this.grid.setAttributeOnSelectedItems('archived_at', null).always(() => {
          this.grid.setSelectedRows([]);
          this.filtersChanged();
        })
      ));
    }
    return false;
  },


  batchUpdateTags: function(e) {
    const tagsStr = this.$('input.tag_names').val();
    const isAdd = $(e.currentTarget).hasClass('batch_add_tags');
    const tagAction = isAdd ? 'add' : 'remove';

    if (tagsStr === '') {
      if(isAdd)
        customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');
      else
        customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
      return;
    }

    this.grid.remoteRequest({
      url: `/clubs/${this.clubId}/batch_update_experiences_tags.json`,
      params: (selectedIds) => { return { experience_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr } },
      done: (dataView, data) => {
        dataView.beginUpdate()
        data.forEach((memberData) => {
          var member = dataView.getItemById(memberData.id)
          member.tag_names = memberData.tag_names
          dataView.updateItem(member.id, member)

          if (isAdd) {
            member.tag_names.forEach((tag) => {
              if (!this.tags.includes(tag)) {
                this.tags.push(tag)
                this.$('select.filter_by_tag').append('<option value="'+tag+'">'+tag+'</option>')
              }
            })
          }
        })
        dataView.endUpdate();
        this.$('input.tag_names').select2('val', '');
      }
    })
  },

  updateBulkOpVisibility: function() {
    const grid = this.grid.slickGrid
    const data = grid.getData()
    const items = grid.getSelectedRows().map(i => data.getItem(i))

    const itemsEmpty = items.length == 0

    const disableMessageFuncs = {
      noneSelected: (action) => itemsEmpty && `To ${action}, please select at least one experience.`
    }

    const shouldDisable = {
      tags: { action: "set tags", disablers: ["noneSelected"] },
      make_active: { action: "enable", disablers: ["noneSelected"] },
      make_inactive: { action: "disable", disablers: ["noneSelected"] },
      delete: { action: "delete members", disablers: ["noneSelected"] },
      archive: { action: "enable", disablers: ["noneSelected"] },
      unarchive: { action: "enable", disablers: ["noneSelected"] }
    }

    let disableMessages = {}
    Object.entries(shouldDisable).forEach(([op, info]) => {
      info.disablers.forEach(disabler => {
        const message = disableMessageFuncs[disabler](info.action)
        if (message) {
          disableMessages[op] = message
          return
        }
      })
    })

    this.$("[data-bulk-op]").each((idx, el) => {
      const elem = $(el)
      const op = elem.data("bulk-op")
      const disableMessage = disableMessages[op]

      if (disableMessage) {
        elem.addClass("bulk-op-disabled")
        elem.data("disabled", disableMessage)
      } else {
        elem.removeClass("bulk-op-disabled")
        elem.removeData("disabled")
        elem.removeAttr("data-disabled")
      }
    })

    this.$('.bulk_op').hide();
  },

  getFilterByViewingArchives: (viewingArchives) => {
    return (item) => {
      if (viewingArchives) {
        return !!item.archived_at
      }
      if (!viewingArchives) {
        return !item.archived_at
      }
    }
  },

  /*
   * misc
   */

  resizeGrid: function() {
    // Don't resize anything if sizes have been set by the user
    if (this.savedSettings.columnWidths) { return }

    this.grid.slickGrid.resizeCanvas();
    this.grid.slickGrid.autosizeColumns();
  },

  selectTags: function (accumulator, item) {
    return accumulator.concat(item.tag_names || [])
  },

  increaseGridHeight: function() {
    this.changeGridHeight(100);
  },
  decreaseGridHeight: function() {
    this.changeGridHeight(-100);
  },
  experienceAudits: function(e) {
    const experienceId = $(e.currentTarget).data('id');
    $.get("/experiences/"+experienceId+"/audits", function(resp) {
      $('#experiences-info-modal').html(resp).modal();
    });
  },
  changeGridHeight(amount) {
    const $table = $('#experiences_table');
    let height = $table.height();
    if(height + amount < 100) return;
    height += amount;
    $table.height(height).trigger('resize');
    Application.setPreference("experiences_grid_height", height, true);
  },
  initTagInputBoxes: function() {
    this.$('.tag_select2_input').val('').select2({
      openOnEnter: false,
      width: '150px',
      placeholder: 'Experience Tags',
      tokenSeparators: [','],
      tags: this.tags,
      selectOnBlur: true,
      formatNoMatches: function() { return ''; },
      createSearchChoice: (term) => {
        for (var value of this.tags) {
          if (value.toUpperCase() === term.toUpperCase()) {
            return {id: value, text: value};
          }
        }
        return {id: term, text: term}
      }
    });
  }
});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/experiences_view.js